const setStore = (name, content) => {
	if (!name) return
	if (typeof content !== 'string') {
		content = JSON.stringify(content)
	}
	window.localStorage.setItem(name, content)
}

const getStore = name => {
	if (!name) return;
	var data = window.localStorage.getItem(name);
	try{
		return JSON.parse(data);
	}catch(e){
		return data;
	}
	
}

const removeStore = name => {
	if (!name) return
	window.localStorage.removeItem(name)
}



export default {
	put: setStore,
	get: getStore,
	remove: removeStore
}
